import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Form, Dialog, DotLoading } from 'antd-mobile'
import { Toast } from 'antd-mobile'
import dayjs from 'dayjs'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import { StatusCode } from '@/constants'
import { useCommonForm } from '@/hooks'

import HPopup from '../../HYBVant/HPopup'

import config from './config.json'
import './index.less'

const MyPopup: React.FC<any> = ({ visible, onCancel, modalData, hrm_employee_id }) => {
  const {
    current,
    runSave,
    runDelete,
    saveLoading,
    deleteLoading,
    isEmployee,
    runRelieveContracts,
    relieveContractsLoading
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm, isShow }, setState] = useSetState<{
    isShow: boolean
    randomForm: any
  }>({
    isShow: false,
    randomForm: null
  })
  // expiration_date
  const onRemove = () => {
    Dialog.confirm({
      content: '确认要删除吗？',
      confirmText: deleteLoading ? <DotLoading /> : '确认',
      onConfirm: () => {
        runDelete(current?.id)
        Dialog.clear()
      }
    })
  }
  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const start_date_old = current?.expiration_date?.[0] || current?.start_date
      const end_date_old = current?.expiration_date?.[1] || current?.end_date
      current.expiration_date = start_date_old && end_date_old ? [start_date_old, end_date_old] : []
      formIt.setFieldsValue(current)
      setState({ randomForm: Math.random() })
    }
    setFieldValues(current?.id)
  }, [current])
  const onFinish = (values: any) => {
    if (saveLoading) return
    const start_date_old = values?.expiration_date?.[0] || values?.start_date
    const start_date = start_date_old ? dayjs(start_date_old).format('YYYY-MM-DD') : ''
    const end_date_old = values?.expiration_date?.[1] || values?.end_date
    const end_date = end_date_old ? dayjs(end_date_old).format('YYYY-MM-DD') : ''
    const dateA: Date = new Date(start_date) // 示例日期 a
    const dateB: Date = new Date(end_date) // 示例日期 b
    const bool = values.contract_type_code === 'UNLIMITED_TERM_EMPLOYMENT_CONTRACT'
    if (dateA <= dateB || bool) {
      runSave([{ id: current?.id, hrm_employee_id, ...values, start_date, end_date }])
    } else {
      Toast.show({
        content: '有效日起不能晚于有效日止！'
      })
    }
  }
  const onRescindContractFinish = (values: any) => {
    if (relieveContractsLoading) return
    const signValue = values['date']
    const contract_id = current?.contract_id || null
    const ids = contract_id ? [contract_id] : null
    runRelieveContracts({ ids, date: signValue || null })
  }
  const onTerminateContract = () => {
    setState({
      isShow: true
    })
  }
  const onTerminateContractCancel = () => {
    setState({
      isShow: false
    })
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'rescindContract',
        title: '解除合同',
        icon: 'rescindContract',
        onClick: onTerminateContract
      },
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: onRemove
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    const btnss = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: onRemove
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return isEmployee && current?.contract_status_code === 2 && hasDelete
      ? btns
      : hasDelete
        ? btnss
        : btnss.slice(1)
  }
  const { option, optionStatus } = useCommonForm({
    code: 'employeeFile_work_contract_from',
    vars: { isNoHide: false, hide: true, headleContractType: () => {} },
    immediate: true
  })
  return (
    <div>
      <HPopup
        title='合同'
        hasOk={false}
        className='lg list-form-popup'
        visible={visible}
        onCancel={onCancel}
        destroyOnClose
      >
        {optionStatus === StatusCode.done && (
          <NewEditForm
            formInfo={option.formInfo ?? []}
            initialValues={current}
            onFinish={onFinish}
            randomForm={randomForm}
            formButtons={getFormButtons(current?.id)}
          />
        )}
      </HPopup>
      {isShow && (
        <HPopup
          title='解除合同'
          hasOk={false}
          className='lg list-form-popup'
          visible={isShow}
          onCancel={onTerminateContractCancel}
          destroyOnClose
        >
          <NewEditForm
            formInfo={config?.work_rescind_contract_from?.formInfo ?? []}
            initialValues={{}}
            onFinish={onRescindContractFinish}
            formButtons={[
              {
                key: 'remove3',
                title: '取消',
                className: 'cancel',
                onClick: onTerminateContractCancel
              },
              {
                key: 'submit',
                title: '保存'
              }
            ]}
          />
        </HPopup>
      )}
    </div>
  )
}

export default MyPopup
